import { inject, Injectable } from '@angular/core';
import { AccessTokenService } from './access-token.service';
import { Router, UrlTree } from '@angular/router';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthNavigationService {
  accessTokenService = inject(AccessTokenService);
  router = inject(Router);

  ensurePrivate$() {
    return this.accessTokenService.ensurePrivateSession$().pipe(take(1));
  }

  getUrlToRedirect(url: string): UrlTree {
    const currentUrl = this.router.routerState.snapshot.url || '/';
    return this.router.createUrlTree([url], {
      queryParams: { returnUrl: currentUrl },
    });
  }
}
